import { useState } from "react";

export function LayerToggle(props: { className?: string, id: string, toggled: boolean, disabled?: boolean, onClick?: () => void }) {
    const [state, setState] = useState<boolean>(props.toggled);
    return <div id={props.id} className={`${props.className}`}>
        <div className="form-check form-switch mx-auto my-auto m-0 text-center">
            <input className="form-check-input efas-form-check-input" type="checkbox" defaultChecked={state} role="button"
                onClick={() => {
                    if (props.disabled) {
                        return;
                    }
                    setState(!state);
                    if (props.onClick) props.onClick();
                }} />
        </div>
    </div>
};
